import { useAxios } from './axiosService';

export const useCreditsService = () => {
    const { axios } = useAxios();

    const getUserCredits = async () => {
        try {
            const response = await axios.get('/credits');
            return response.data.credits;
        } catch (error) {
            console.error('Failed to fetch user credits:', error);
            throw error;
        }
    };

    const getStripeCreditsPrices = async () => {
        const { data } = await axios.get('/credits/stripe-credits-prices');
        return data.prices;
    };

    return { getUserCredits, getStripeCreditsPrices };
};
